import { render, staticRenderFns } from "./ProducaoRepasseForm.vue?vue&type=template&id=36edaefd&scoped=true"
import script from "./ProducaoRepasseForm.vue?vue&type=script&lang=js"
export * from "./ProducaoRepasseForm.vue?vue&type=script&lang=js"
import style0 from "./ProducaoRepasseForm.vue?vue&type=style&index=0&id=36edaefd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edaefd",
  null
  
)

export default component.exports